import React from 'react'

export type ModalSize = 'sm' | 'md' | 'lg' | 'xl'

export type ModalDialogContextValue = {
  size: ModalSize
  ariaLabelledBy: string
  handleClose: () => void
}

export const ModalDialogContext = React.createContext<ModalDialogContextValue>({
  size: 'sm',
  ariaLabelledBy: '',
  handleClose: () => {},
})
